import { addColumnAfter, addColumnBefore, addRowAfter, addRowBefore, CellSelection, deleteColumn, deleteRow, deleteTable, goToNextCell, mergeCells, splitCell, } from 'prosemirror-tables';
import { NODE_NAME } from './const';
var isInList = function ($pos) { return $pos.parent.type.name === 'list_item'; };
var createCellAttrs = function (defaultColWidth, extraAttrs) {
    if (extraAttrs === void 0) { extraAttrs = {}; }
    var attrs = {
        colspan: {
            default: 1,
        },
        rowspan: {
            default: 1,
        },
        colwidth: {
            default: [defaultColWidth],
        },
    };
    Object.keys(extraAttrs).forEach(function (key) {
        attrs[key] = { default: extraAttrs[key].default };
    });
    return attrs;
};
var getCellAttrs = function (dom, extraAttrs) {
    if (extraAttrs === void 0) { extraAttrs = {}; }
    var widthAttr = dom.getAttribute('data-colwidth');
    var widths = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map(function (s) { return Number(s); }) : null;
    var colspan = Number(dom.getAttribute('colspan') || 1);
    var result = {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: widths && widths.length === colspan ? widths : null,
    };
    Object.keys(extraAttrs).forEach(function (prop) {
        var getter = extraAttrs[prop].getFromDOM;
        var value = getter && getter(dom);
        if (value !== null)
            result[prop] = value;
    });
    return result;
};
var setCellAttrs = function (node, extraAttrs) {
    if (extraAttrs === void 0) { extraAttrs = {}; }
    var attrs = {};
    if (node.attrs.colspan !== 1)
        attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1)
        attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth)
        attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    Object.keys(extraAttrs).forEach(function (prop) {
        var setter = extraAttrs[prop].setDOMAttr;
        if (setter)
            setter(node.attrs[prop], attrs);
    });
    return attrs;
};
var createRow = function (type, _column, config) {
    var content = [];
    var col = _column;
    var attrs = type === NODE_NAME.TABLE_CELL ? { colwidth: [config.cellWidth] } : undefined;
    while (col--) {
        content.push({ type: type, attrs: attrs, content: [{ type: 'paragraph' }] });
    }
    return {
        type: NODE_NAME.TABLE_ROW,
        content: content,
    };
};
var createTableNode = function (_row, column, config) {
    if (!_row || !column)
        return null;
    var row = _row;
    var content = [];
    if (config.useTableHeader) {
        content.push(createRow(NODE_NAME.TABLE_HEADER, column, config));
        row--;
    }
    while (row--) {
        content.push(createRow(NODE_NAME.TABLE_CELL, column, config));
    }
    return { type: NODE_NAME.TABLE, content: content };
};
var closestNode = function ($pos, nodeNames) {
    var depth = $pos.depth;
    var _loop_1 = function () {
        var node = $pos.node(depth);
        if (nodeNames.some(function (name) { return name === node.type.name; })) {
            return { value: { node: node, from: $pos.before(depth), to: $pos.after(depth) } };
        }
        depth--;
    };
    while (depth > 0) {
        var state_1 = _loop_1();
        if (typeof state_1 === "object")
            return state_1.value;
    }
};
var closestCell = function ($pos) { return closestNode($pos, [NODE_NAME.TABLE_CELL, NODE_NAME.TABLE_HEADER]); };
var closestTable = function ($pos) { return closestNode($pos, [NODE_NAME.TABLE]); };
var goToCell = function (state, dispatch, dir) {
    if (dir === void 0) { dir = 1; }
    var $from = state.selection.$from;
    var tableInfo = closestTable($from);
    if (!tableInfo)
        return false;
    var table = tableInfo.node;
    if (isInList($from))
        return false;
    var cellInfo = closestCell($from);
    if (!cellInfo)
        return false;
    var cell = cellInfo.node;
    if (dir === -1 && table.firstChild && cell === table.firstChild.firstChild)
        return true;
    else if (dir === 1 && table.lastChild && cell === table.lastChild.lastChild)
        return true;
    return goToNextCell(dir)(state, dispatch);
};
// get the total number of cells in the table
var getTableLength = function (node) {
    if (node.type.name === 'table') {
        var rowLength = node.childCount;
        var colLength = (node.firstChild && node.firstChild.childCount) || 0;
        return rowLength * colLength;
    }
    return 0;
};
var judgeSelectAllTable = function (editor) {
    try {
        var _a = editor.view.state.selection, ranges = _a.ranges, $head = _a.$head;
        var tableNode = $head.node(1);
        return ranges.length === getTableLength(tableNode);
    }
    catch (e) {
        return false;
    }
};
var cellWrapping = function ($pos) {
    for (var d = $pos.depth; d > 0; d--) {
        var role = $pos.node(d).type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell')
            return $pos.node(d);
    }
    return null;
};
var canSplitCell = function (editor) {
    var sel = editor.view.state.selection;
    var cellNode;
    if (!(sel instanceof CellSelection)) {
        cellNode = cellWrapping(sel.$from);
        if (!cellNode)
            return false;
    }
    else {
        if (sel.$anchorCell.pos !== sel.$headCell.pos)
            return false;
        cellNode = sel.$anchorCell.nodeAfter;
    }
    if (cellNode && cellNode.attrs.colspan === 1 && cellNode.attrs.rowspan === 1) {
        return false;
    }
    return true;
};
var tableOperation = {
    cut: function (editor) {
        var state = editor.view.state;
        editor.focus();
        var sel = state.selection;
        if (sel.empty)
            return;
        return document.execCommand('cut');
    },
    copy: function (editor) {
        editor.focus();
        return document.execCommand('copy');
    },
    mergeCells: function (editor) {
        var _a = editor.view, state = _a.state, dispatch = _a.dispatch;
        return mergeCells(state, dispatch);
    },
    splitCells: function (editor) {
        var _a = editor.view, state = _a.state, dispatch = _a.dispatch;
        return splitCell(state, dispatch);
    },
    addRowBefore: function (editor) {
        var _a = editor.view, state = _a.state, dispatch = _a.dispatch;
        return addRowBefore(state, dispatch);
    },
    addRowAfter: function (editor) {
        var _a = editor.view, state = _a.state, dispatch = _a.dispatch;
        return addRowAfter(state, dispatch);
    },
    addColumnBefore: function (editor) {
        var _a = editor.view, state = _a.state, dispatch = _a.dispatch;
        return addColumnBefore(state, dispatch);
    },
    addColumnAfter: function (editor) {
        var _a = editor.view, state = _a.state, dispatch = _a.dispatch;
        return addColumnAfter(state, dispatch);
    },
    deleteRow: function (editor) {
        var _a = editor.view, state = _a.state, dispatch = _a.dispatch;
        return deleteRow(state, dispatch);
    },
    deleteColumn: function (editor) {
        var _a = editor.view, state = _a.state, dispatch = _a.dispatch;
        return deleteColumn(state, dispatch);
    },
    deleteTable: function (editor) {
        var _a = editor.view, state = _a.state, dispatch = _a.dispatch;
        return deleteTable(state, dispatch);
    },
    canSplitCell: function (editor) { return canSplitCell(editor); },
};
export { canSplitCell, closestCell, closestTable, createCellAttrs, createTableNode, getCellAttrs, goToCell, judgeSelectAllTable, setCellAttrs, tableOperation, };
//# sourceMappingURL=utils.js.map